import { useCallback, useEffect, useState } from 'react'

import { Announcement, AnnouncementAlert } from '.'
import { findFirstUnacknowledgedAlert } from './utils'

export type AnnouncementsContainerProps = {
  announcements?: Announcement[] | readonly Announcement[]
}

export default function AnnouncementsContainer({
  announcements,
}: AnnouncementsContainerProps) {
  const [active, setActive] = useState<Announcement | null>(null)

  const findActive = useCallback(() => {
    if (!announcements?.length) {
      return null
    }

    const firstUnacknowledgedIndex = findFirstUnacknowledgedAlert(
      announcements.map(({ id }) => id),
    )
    if (firstUnacknowledgedIndex >= 0) {
      return announcements[firstUnacknowledgedIndex]
    }

    return null
  }, [announcements])

  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (active || !announcements?.length) {
      return
    }

    const newActive = findActive()
    if (newActive) {
      timeout = setTimeout(() => setActive(newActive), 200)
    } else {
      setActive(null)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [active, announcements, findActive])

  if (!announcements?.length || !active) {
    return null
  }

  return (
    <AnnouncementAlert announcement={active} onClose={() => setActive(null)} />
  )
}
